/**
 * Digitize — the client side of `POST /digitize/run`.
 *
 * The actual raster-to-vector pipeline lives entirely server-side
 * (`backend/digitize_router.py` — threshold, trace contours, skeletonize
 * thin lines); this file's only job is the request/response shape, the same
 * thin-mirror-of-the-backend-schema pattern `qualityCheckService.ts` already
 * uses for Find Problems.
 */

import { api } from './apiClient';

export type DigitizeSimplification = 'low' | 'medium' | 'high';

export interface DigitizedFeature {
  type: 'Feature';
  properties: { shape: 'line' | 'polygon'; source: 'digitize' };
  geometry: GeoJSON.Geometry;
}

export interface DigitizeResult {
  features: DigitizedFeature[];
  lineCount: number;
  polygonCount: number;
}

export const digitizeService = {
  async run(
    imageBase64: string,
    mimeType: string,
    /** [west, south, east, north] — the same box this raster layer is
     *  already drawn at (`Layer.bounds`). */
    bounds: [number, number, number, number],
    simplification: DigitizeSimplification,
  ): Promise<DigitizeResult> {
    return api.post<DigitizeResult>('/digitize/run', {
      imageBase64,
      mimeType,
      bounds,
      simplification,
    });
  },
};
